// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosBox--ikT0M {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px 10px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosHeader--feT3Z .src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__left--hz_jE {
  flex: 1;
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosHeader--feT3Z .src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__left--hz_jE .src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__title--TJp6h {
  font-weight: bold;
  flex: 1;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosMain--LWLsw {
  flex: 1;
  overflow: auto;
  position: relative;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__loaderBox--_yjIa {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aPositions/Bom2aPositions.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,iBAAA;AAAF;AAGA;EAEI,OAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAFJ;AAHA;EAOM,iBAAA;EACA,OAAA;AADN;AAMA;EACE,OAAA;EACA,cAAA;EACA,kBAAA;AAJF;AAOA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AALF","sourcesContent":[".bomPosBox {\n  height: 100%;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  padding: 5px 10px; // возможно, это приведёт к неудачному отображению полос прокруток\n}\n\n.bomPosHeader {\n  .left {\n    flex: 1;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    .title {\n      font-weight: bold;\n      flex: 1;\n    }\n  }\n}\n\n.bomPosMain {\n  flex: 1;\n  overflow: auto;\n  position: relative;\n}\n\n.loaderBox {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.4);\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bomPosBox": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosBox--ikT0M`,
	"bomPosHeader": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosHeader--feT3Z`,
	"left": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__left--hz_jE`,
	"title": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__title--TJp6h`,
	"bomPosMain": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__bomPosMain--LWLsw`,
	"loaderBox": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositions-module__loaderBox--_yjIa`
};
export default ___CSS_LOADER_EXPORT___;
